import React from 'react';
import { Users, Plus } from 'lucide-react';
import DashboardHeader from '@/components/dashboard/DashboardHeader';

interface UsersHeaderProps {
  isAdmin?: boolean;
  onAddUser?: () => void;
  'data-test-id'?: string;
}

const UsersHeader: React.FC<UsersHeaderProps> = ({ 
  isAdmin, 
  onAddUser, 
  'data-test-id': testId 
}) => {
  return (
    <DashboardHeader 
      title="Contacts"
      description="Manage your contacts and team members"
      icon={<Users size={24} />}
      primaryAction={isAdmin && onAddUser ? {
        label: "Add Contact",
        icon: Plus,
        onClick: onAddUser
      } : undefined}
      data-test-id={testId}
    />
  );
};

export default UsersHeader; 